import React from 'react';
import { FormattedMessage } from 'react-intl';
import AvatarImg from '../../../../components/avatar-img';
import '../../../css/organizer-card.css';

const OrganizerCard = (props) => {
  const { organizer, isOrganizerLoggedIn } = props;
  const { fullName, email } = organizer;

  return (
    <div className="organizer-card row">
      <div className="col-12 col-md-3">
        <AvatarImg user={organizer} />
      </div>
      <div className="col-12 col-md-9">
        <h3 className="mt-2 mb-0 organizer-name">
          <i className="fa fa-fw fa-star clear-blue" />
          {fullName}
        </h3>
        <p className="ml-1 contribution-muted-text">
          <FormattedMessage
            id="organizerCard.organizer"
            defaultMessage="Organizer"
          />
          { !isOrganizerLoggedIn &&
            <a
              href={`mailto:${email}`}
              target="_blank"
              rel="noopener noreferrer"
              className="small-print"
            >
              <i className="fa fa-fw ml-2 fa-envelope-o" />
            </a>
          }
        </p>
      </div>
    </div>
  );
};

OrganizerCard.defaultProps = {
  organizer: null,
  isOrganizerLoggedIn: false,
};

export default OrganizerCard;



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-dashboard/group-summary/organizer-card.js